// Shared referral-overlay coordination so only one referral element shows at a time.
let cardVisible = false;
const cardSubs = new Set();
let loginSuppressed = false;
const supSubs = new Set();

export const setRefCardVisible = (v) => { cardVisible = v; cardSubs.forEach((f) => f(v)); };
export const isRefCardVisible = () => cardVisible;
export const subscribeRefCard = (f) => { cardSubs.add(f); return () => cardSubs.delete(f); };

export const setLoginCardSuppressed = (v) => { loginSuppressed = v; supSubs.forEach((f) => f(v)); };
export const isLoginCardSuppressed = () => loginSuppressed;
export const subscribeLoginSuppressed = (f) => { supSubs.add(f); return () => supSubs.delete(f); };
